import React from "react";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useConnectionInThisTab } from "../services/websocket";
import { useWsConnection } from "../redux/wsConnection";
import { isReadingRoute } from "../services/websocketRoute";

export default function OtherLoginNotice() {
  const { t } = useTranslation("common");
  const router = useRouter();
  const { otherLoginShow, otherLoginSameBrowser } = useWsConnection();

  if (
    !otherLoginShow ||
    otherLoginSameBrowser ||
    isReadingRoute(router.asPath)
  ) {
    return null;
  }

  return (
    <div
      role="status"
      className="relative z-20 flex w-full flex-wrap items-center justify-between gap-2 border-y border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-950"
    >
      <span>{t("Live updates are active elsewhere")}</span>
      <button
        type="button"
        onClick={useConnectionInThisTab}
        className="rounded-md border border-amber-300 bg-white px-3 py-1.5 font-semibold text-amber-950 hover:bg-amber-100"
      >
        {t("Use this tab")}
      </button>
    </div>
  );
}
